import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { PropsWithChildren } from "react";
import { formatNumber } from "util/formatNumber";

type MonthWasteDataItemProps = {
  label: string;
  amount: number | null;
  color?: string;
} & PropsWithChildren;

export function MonthWasteDataItem({ label, amount, color, children }: MonthWasteDataItemProps) {
  return (
    <Stack
      sx={{
        px: 2,
        py: 1,
        bgcolor: "background.paper",
        borderRadius: "4px",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          {color && (
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: color,
                borderRadius: "2px",
              }}
            />
          )}
          <Typography variant="caption" color="textSecondary">
            {label}
          </Typography>
        </Stack>
        {amount != null && (
          <Typography variant="body2" fontWeight={400} color="textPrimary">
            {`${formatNumber(amount)} lbs`}
          </Typography>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
